import { useCallback } from "react";
import { MessageDescriptor, PrimitiveType, useIntl } from "react-intl";

const useTranslateMessage = function () {
  const intl = useIntl();
  // Stable across renders (only changes when `intl` itself does, e.g. on
  // locale change) - callers pass this into effect/memo/callback dependency
  // arrays, and an unstable reference here previously caused ManageCompanyModal's
  // duplicate-tax-id error effect to re-fire and update state every render,
  // an infinite loop.
  return useCallback(
    (message: MessageDescriptor, values?: Record<string, PrimitiveType>) => {
      return intl.formatMessage(message, values);
    },
    [intl],
  );
};

export default useTranslateMessage;
